
import { defineComponent, ref, onBeforeMount, computed, PropType } from "vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import { format } from "date-fns";
import * as Locales from 'date-fns/locale';

import EasyDrop from "@/components/EasyDrop.vue";
import { LocaleStrings } from "@/types/paramModels";

export default defineComponent({
  name: 'SearchDatePicker',
  emits: ["updateDate", "updateFlexibleDate"],
  components: {
    EasyDrop,
    Datepicker
  },
  props: {
    dateFrom: {
      type: String,
      required: true,
    },
    dateTo: {
      type: String,
      required: true,
    },
    showFlexibleDate: {
      type: Boolean
    },
    flexibleDate: {
      type: Number,
      required: true
    },
    pageTexts: {
      type: Object,
      required: true
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    },
    isHotelApp: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  setup(_props, { emit }) {
    const date = ref();
    let hasDate = ref(false);
    const easyDrop = ref();

    const formatLocale = computed(() => Locales[_props.localeStrings.name]);

    const weekDays = computed(() => {
      return ['M', 'T', 'O', 'T', 'F', 'L', 'S'];
    })

    const flexDate = ref(_props.flexibleDate);

    const flexDayButtonText = computed(() => {
      if (_props.flexibleDate === 1) return "+/- 1 " + _props.pageTexts['searchbarDateLabelDay'];
      else if (_props.flexibleDate > 1) return "+/- " + _props.flexibleDate + " " + _props.pageTexts['searchbarDateLabelDays'];
      return _props.pageTexts['searchbarDateLabelExactDate'];
    })

    const formatLongDate = (dateString: Date | string) => {
      return format(new Date(dateString), "do LLLL yyyy", { locale: Locales[_props.localeStrings.name] });
    };
    const formatShortDate = (dateString: Date | string) => {
      return format(new Date(dateString), "do MMM yyyy", { locale: Locales[_props.localeStrings.name] });
    };

    onBeforeMount(() => {
      hasDate.value = _props.dateFrom !== null && _props.dateTo !== null;
      const startDate = _props.dateFrom !== null ? new Date(_props.dateFrom) : new Date(new Date().setDate(new Date().getDate() + 14));
      const endDate = _props.dateTo !== null ? new Date(_props.dateTo) : new Date(new Date().setDate(new Date().getDate() + 21));
      date.value = [startDate, endDate];
    });

    const updateFlexDate = (newFlexDate: number) => {
      flexDate.value = newFlexDate;
      emit("updateFlexibleDate", newFlexDate);
    }

    const handleDate = (modelData) => {
      hasDate.value = true
      if (modelData) {
        date.value = modelData;
      }
      emit("updateDate", format(date.value[0], "yyyy-MM-dd"), format(date.value[1], "yyyy-MM-dd"))
    }

    const closeDropdown = () => {
      if (easyDrop.value)
        easyDrop.value.toggleDropdown();
    }

    const nextDrop = () => {
      document.getElementById('searchAirportBtn')?.click();
    }

    return {
      easyDrop,
      closeDropdown,
      date,
      flexDate,
      updateFlexDate,
      formatLongDate,
      formatShortDate,
      hasDate,
      handleDate,
      flexDayButtonText,
      formatLocale,
      weekDays,
      nextDrop
    };
  },
});
